import { SessionStorageService, useUserContext } from '@ion/user';

import { routes } from 'app/constants';
import buildRedirectUri from 'app/auth0/buildRedirectUri';

export default function useAfterOrgSwitch() {
  const { loginWithRedirect } = useUserContext();

  function afterOrgSwitch({ orgId, isOverride = false }) {
    localStorage.setItem('redirectPath', routes.home);

    SessionStorageService.switchOrg({ orgId, isOverride });

    if (isOverride) {
      window.location.reload();
    } else {
      loginWithRedirect({
        organization: orgId,
        redirectUri: buildRedirectUri(routes.orgSwitchRedirect),
      });
    }
  }

  return afterOrgSwitch;
}
